<div [formGroup]="form" [libGridCell]="config.grid">
  @if (config.type === customFormElements.hidden) {
    <hidden
      [group]="form"
      [config]="config"
      data-test-id="hiddenElement"
    ></hidden>
  }

  @if (config.type === customFormElements.termsAndConditions) {
    <terms-and-conditions
      [config]="config"
      [group]="form"
      data-test-id="termsAndConditions"
    ></terms-and-conditions>
  }

  @if (config.type === customFormElements.coverageEffective) {
    <coverage-effective-control
      (formCreated)="formCreated.emit($event)"
      [group]="form"
      [config]="config"
      [prefillVal]="prefillVal"
      data-test-id="coverageEffectiveControl"
    >
    </coverage-effective-control>
  }

  @if (config.type === customFormElements.autopay) {
    <autopay [form]="form" [config]="config" data-test-id="autopay"></autopay>
  }

  @if (config.type === customFormElements.broker_assistance) {
    <broker-assistance
      [config]="config"
      [form]="form"
      data-test-id="brokerAssistance"
    ></broker-assistance>
  }

  @if (config.type === customFormElements.passwords) {
    <passwords
      [config]="config"
      [group]="form"
      data-test-id="passwords"
    ></passwords>
  }

  @if (config.type === customFormElements.whoseCovered) {
    <whose-covered
      (formCreated)="formCreated.emit($event)"
      [group]="form"
      [direction]="direction"
      [config]="config"
      [prefillVal]="prefillVal"
      data-test-id="whoseCovered"
    >
    </whose-covered>
  }

  @if (config.type === customFormElements.industryGroup) {
    <industries
      [formControlName]="config.prop"
      [direction]="direction"
      [config]="config"
      data-test-id="industries"
    ></industries>
  }

  @if (config.type === customFormElements.address) {
    <address
      [formControlName]="config.prop"
      [config]="config"
      data-test-id="address"
    ></address>
  }

  @if (config.type === customFormElements.companyAddress) {
    <company-address
      [formControlName]="config.prop"
      [config]="config"
      data-test-id="companyAddress"
    ></company-address>
  }

  @if (config.type === customFormElements.basicAddress) {
    <basic-address
      [direction]="direction"
      [config]="config"
      [group]="form"
      data-test-id="basicAddress"
    ></basic-address>
  }

  @if (config.type === customFormElements.officeHours) {
    <office-hours
      [direction]="direction"
      [config]="config"
      [group]="form"
      data-test-id="officeHours"
    ></office-hours>
  }

  @if (config.type === customFormElements.formArray) {
    <form-array
      [group]="form"
      [formArrayConfig]="config"
      [direction]="direction"
      data-test-id="formArray"
    ></form-array>
  }

  @if (
    config.type === customFormElements.dropdownOther && form.get(config.prop)
  ) {
    <div>
      <dropdown-other
        [direction]="direction"
        [config]="config"
        [group]="form"
        data-test-id="dropdownOther"
      ></dropdown-other>
    </div>
  }

  @if (config.type === customFormElements.optionalDate) {
    <div>
      <optional-date
        [direction]="direction"
        [config]="config"
        [group]="form"
        data-test-id="optionalDate"
      ></optional-date>
    </div>
  }

  @if (config.type === customFormElements.inputNA && form.get(config.prop)) {
    <div>
      <input-na
        [formControlName]="config.prop"
        [direction]="direction"
        [config]="config"
        data-test-id="inputNA"
      ></input-na>
    </div>
  }

  @if (config.type === customFormElements.ssnMultiField) {
    <div>
      <ssn-multi-field
        [formControlName]="config.prop"
        [config]="config"
        [group]="form"
        data-test-id="ssnMultiField"
      ></ssn-multi-field>
    </div>
  }
</div>
